// React Imports
import React from 'react';

// Mui Imports
import {Avatar, Tooltip} from '@mui/material';
import {GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import {deepOrange, green} from "@mui/material/colors";

// App Imports
import WorkIssuanceStatusMenu from "../Status/WorkIssuanceStatusMenu";


// main function
export const WorkIssuanceTaxGridColumns = ({ hideActions,  handleMousedRow, cashState, accrualState, liabilityState, ultimatesState  }) =>

    // ***************** BEGIN COLUMNS ***************************

    [
    {
        field: 'id',
        headerName: 'id',
        description: '',
        sortable: true,
        editable: true,
        width: 60,
        hide: true
    },

    {
        field: 'reuseMarket',
        headerName: 'Reuse Market',
        description: '',
        sortable: false,
        editable: true,
        width: 300,
    },
    //
    {
        field: 'cdpId',
        headerName: 'cdpId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'dataPointId',
        headerName: 'dataPointId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },

    {
        field: 'taxAmount',
        headerName: 'raw taxAmount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'displayTaxAmount',
        headerName: cashState === true ? 'Estimated Tax' :
            accrualState === true ? 'Accrual Tax Estimate':
                liabilityState === true ? 'Liability Tax Estimate':
                ultimatesState === true ? 'Ultimate Tax Estimate' : 'Estimated Tax',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 160,
        hide: false
    },
    {
        // field: 'mockIndicator',
        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        type: 'actions',  // Required for built-in expand behavior
        headerName: 'Expression',
        renderCell: (contracts) =>
        {
            if(contracts.row.contractLevel === 'Cast'){
                return (
                    <Tooltip title={"Click to view payee details."}>
                        <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: green[500] }}>p</Avatar>
                    </Tooltip>)}
            // if(contracts.row.mockIndicator=='m'){
            //     return (
            //         <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{contracts.row.mockIndicator} </Avatar>)}
        },
        description: '',
        sortable: false,
        width: 90,
    },
    {
        field: "more",
        headerName: '',
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filter: false,
        hide: false,
        renderCell: (contracts) => {
            return (<div onMouseOver = {() => handleMousedRow(contracts.row)}  >
                    {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
                    <WorkIssuanceStatusMenu/>
                </div>
            );
        }

    },

    {
        field: 'displayTaxableAmount',
        headerName: cashState === true ? 'Taxable Amount' :
            accrualState === true ? 'Accrual Taxable Amount':
                liabilityState === true ? 'Liability Taxable Amount':
                ultimatesState === true ? 'Ultimate Taxable Amount' : 'Taxable Amount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 180,
        hide: false
    },
    {
        field: 'displayTaxPercentage',
        headerName: 'Estimated Tax Rate',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 150,
        hide: false
    },

    {    field: 'contractId',
        headerName: 'Contract ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {
        field: 'contractName',
        headerName: 'On Contract',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        // editable: true,
        width: 350,
        hide: false
    },
    {
        field: 'taxExemptName',
        headerName: 'Exempt',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        // editable: true,
        width: 70,
        hide: false
    },
    {
        field: 'dataType',
        headerName: 'dataType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'sourceType',
        headerName: 'sourceType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'dataPointRange',
        headerName: 'Range',
        description: '',
        sortable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'cdpId',
        headerName: 'CDP ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'cdpvId',
        headerName: 'CDPV ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'iterationNumber',
        headerName: '#',
        description: '',
        sortable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 15,
        hide: true
    },

    {
        field: 'hierarchyLevel',
        headerName: 'hierarchyLevel',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchyOrder',
        headerName: 'hierarchyOrder',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchy',
        headerName: 'Hierarchy',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },

];

// *************** END COLUMNS *******************************